
var Reflux = require("reflux");
var Intl = require("intl");
var ReactIntl = require("react-intl");
var config = require("app/util/config/config");
var ReactCSSTransitionGroup = React.addons.CSSTransitionGroup;
var apiFactory= require("app/util/api/factory");
var UserAvatar= require("app/shared/components/User/user-avatar");
var Social= require("./social");
var DealStatusBox = require("./deal-status-box");
var Icon = require("app/shared/components/Icon/icon");
var moment = require("moment");
var cx = require("classnames");

var DisplayTextMixin = {
  toLowerCase: function(text) {
    if (text && text.toLowerCase) {
      return (
        <span>
          {text.toLowerCase()}
        </span>
      );
    } else {
      return text;
    }
  }
};

var HoverLoader = React.createClass({
  render: function () {
    var imageUrl = config.app.webAppURL + "/images/hover-loader.gif";
    return (
      <div className="hover-loader ta-c pv-lg">
        <span className="img-helper-centralize"></span>
        <img className="hover-loader-img" src={imageUrl}></img>
      </div>
    );
  }
});

var Address = React.createClass({
  getFormatted: function () {
    return this.props.data && this.props.data.formatted? this.props.data.formatted : "";
  },
  formatLine1: function () {
    var line = [];
    this.props.data.street_name? line.push(this.props.data.street_name) : null;
    this.props.data.street_number? line.push(this.props.data.street_number) : null;
    this.props.data.additional_info? line.push(this.props.data.additional_info) : null;
    this.props.data.district? line.push(this.props.data.district) : null;
    return line.join(", ");
  },
  formatLine2: function () {
    var line = [];
    this.props.data.postal_code? line.push("CEP: " + this.props.data.postal_code) : null;
    this.props.data.city? line.push(this.props.data.city.name) : null;
    this.props.data.state? line.push(this.props.data.state) : null;
    this.props.data.country? line.push(this.props.data.country) : null;
    return line.join(" - ");
  },
  hasLine1: function () {
    return this.props.data.street_name
      || this.props.data.street_number
      || this.props.data.additional_info
      || this.props.data.district;
  },
  hasLine2: function () {
    return this.props.data.postal_code
      || this.props.data.city
      || this.props.data.state
      || this.props.data.country;
  },
  isEmpty: function () {
    return !this.hasLine1() && !this.hasLine2();
  },
  render: function () {
    var value = (<div>
      {this.hasLine1()? <div>{this.formatLine1()}</div> : null}
      {this.hasLine2()? <div>{this.formatLine2()}</div> : null}
    </div>);
    return (<HoverValue value={value} isEmpty={this.isEmpty()}/>);
  }
});

var Birthday = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  getToday: function () {
    return this.props.today || moment();
  },
  getDate: function () {
    return moment(moment(this.props.data).valueOf());
  },
  getDaysLeft: function () {
    var today = this.getToday();
    var birthday = this.getDate().year(today.year());
    if (today.isAfter(birthday)) {
      birthday.add(1, "year");
    }
    return Math.ceil(birthday.diff(today, "days", true));
  },
  render: function () {
    if (!this.props.data) {
      return (
        <HoverValue value={this.props.data}/>
      );
    } else {
      var birthdayDate = this.getDate();
      var date = this.formatDate(birthdayDate, {
        day: "numeric",
        month: "long"
      });
      var relativeMessage = this.getIntlMessage("birthday.relative");
      var dateRelative = this.formatMessage(relativeMessage, {
        days: this.getDaysLeft()
      });
      var value = (<span>
        <span>{date}</span>
        <span className="hover-secondary-text" dangerouslySetInnerHTML={{__html: dateRelative}}></span>
      </span>);
      return (
        <HoverValue value={value}/>
      );
    }
  }
});

var EndPeriod = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  getToday: function () {
    return this.props.today || moment();
  },
  getDate: function () {
    return moment(new Date(this.props.endsAt).valueOf());
  },
  getDaysLeft: function () {
    var today = this.getToday();
    var endsAt = this.getDate();
    return Math.ceil(endsAt.diff(today, "days", true));
  },
  getPeriodMessage: function () {
    var daysLeft = this.getDaysLeft();
    var endsAtMessage;
    if (daysLeft >= 0) {
      endsAtMessage = this.getIntlMessage("deal.end_period.on_time");
    } else {
      // if the diff days is negative, the end period is in the past so the deal is delayed
      endsAtMessage = this.getIntlMessage("deal.end_period.delayed");
    }
    // call Math.abs because the diff days can be negative
    return this.formatMessage(endsAtMessage, {
      days: Math.abs(daysLeft),
      deal_status: this.props.dealStatus.id
    });
  },
  render: function () {
    if (!this.props.endsAt) {
      var endsAtMessage = this.getIntlMessage("deal.undefined_period");
      return (
        <HoverValue value={endsAtMessage}/>
      );
    } else {
      var endsAtMessage = this.getPeriodMessage();
      var value = <span dangerouslySetInnerHTML={{__html: endsAtMessage}}></span>;
      return (
        <HoverValue value={value}/>
      );
    }
  }
});

var Phones = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  render: function () {
    var phones = this.props.data.map(function (phone) {
      var message = this.getIntlMessage("phone.type."+phone.type);
      return <li key={phone.type}>
        <a href={"tel:0" + phone.number.replace(/\(|\)|\s+/g, "")}>{phone.number}</a>
        <em className="hover-secondary-text ml-5">{message}</em>
      </li>;
    }.bind(this));
    return (<HoverValue value={phones}/>);
  }
});

var HoverTitle = props => {
  var Title = props.secondary ? "span" : "h5";
  var iconClasses = cx("mr-10", props.secondary ? "o-50" : "fs-20");
  var titleClasses = cx("mt-0", "mb-0", { "text-muted": props.muted });

  return (
    <div className="d-f align-center pt-5">
      {props.icon && <Icon custom icon={props.icon} className={iconClasses} />}
      <Title className={titleClasses}>{props.title}</Title>
      {props.subtitle && <em className="hover-subtitle ml-10">{props.subtitle}</em>}
    </div>
  )
};

var ViewMore = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  getButtonText: function () {
    if (this.props.isTextTruncated) {
      return this.getIntlMessage("view_more");
    } else {
      return this.getIntlMessage("view_less");
    }
  },
  render: function () {
    return (
      <div className="ta-c mt-5">
        <a onClick={this.props.onclick} href="">{this.getButtonText()}</a>
      </div>
    );
  }
});

var TruncateText = React.createClass({
  getInitialState: function() {
    return {
      isTextTruncated: true,
      isViewMoreVisible: false
    };
  },
  showOrHide: function (e) {
    this.setState({
      isTextTruncated: !this.state.isTextTruncated
    }, function () {
      if (this.props.setStateCallback) {
        this.props.setStateCallback();
      }
    });
    e.preventDefault(); // to stop the link from redirecting to another page
  },
  hasText: function () {
    return this.props.text != null && this.props.text.length > 0;
  },
  componentDidMount: function () {
    var text = this.refs.text;
    // if scrollHeight is bigger than offsetHeight, it means that the component has more text than
    // its space. So, the text is being truncated and the show/hide button should be visible
    this.setState({
      isViewMoreVisible: text.offsetHeight < text.scrollHeight
    });
  },
  render: function () {
    var textClasses = cx("p-r", {
      "truncate-text": this.state.isTextTruncated && this.hasText()
    });
    var viewMoreButton;
    if (this.state.isViewMoreVisible) {
      viewMoreButton = <ViewMore onclick={this.showOrHide} isTextTruncated={this.state.isTextTruncated}/>;
    }
    return (
      <div className="mb-10">
        <div ref="text" className={textClasses} dangerouslySetInnerHTML={{__html: this.props.text}}></div>
        {viewMoreButton}
      </div>
    );
  }
});

var HoverDealRelatedTo = ({ organization, person }) => {
  var icon, title, subtitle, muted;

  if (organization) {
    icon = "organization";
    title = organization.name;
  } else if (person) {
    icon = "person";
    title = person.name;
    subtitle = person.role;
  } else {
    title = "Nenhuma empresa ou pessoa relacionada";
    muted = true;
  }

  return (
    <div className="hover-deal-related-to">
      <HoverTitle secondary icon={icon} title={title} subtitle={subtitle} muted={muted} />
    </div>
  );
};


var HoverDealOwner = React.createClass({
  render: function () {
    var avatar;
    if (this.props.userOwner) {
      var avatarURL = this.props.userOwner.avatar ? this.props.userOwner.avatar["70x70"] : null;
      avatar = <UserAvatar name={this.props.userOwner.name} avatarURL={avatarURL}/>;
    } else {
      avatar = "--";
    }
    return (
      <div className="hover-userOwner br-light ta-c p-10 va-middle">
        Responsável:<br/>
        {avatar}
      </div>
    );
  }
});

var HoverDealValue = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  getFormattedValue: function () {
    if (this.props.value && parseFloat(this.props.value) != "NaN") {
      return this.formatNumber(parseFloat(this.props.value), "BRL");
    } else {
      return null;
    }
  },
  render: function () {
    var classes = cx({
      "hover-value-amount fs-20": this.getFormattedValue() != null,
    });
    return (
      <div className="va-middle ta-c w-100 p-10">
        <div className="u-center-h ta-l w-110">
          <div>Valor:</div>
          <div className={classes}>
            <HoverValue value={this.getFormattedValue()} emptyClass="hover-content"/>
          </div>
        </div>
      </div>
    );
  }
});

var HoverEmail = React.createClass({
  render: function () {
    var email = (this.props.emails && this.props.emails[0])?this.props.emails[0]:null;
    return (<div className="hover-email truncate-sentence">
      <HoverEmailLink value={email} dropbox={this.props.dropbox} />
    </div>);
  }
});

var HoverCategory = React.createClass({
  render: function () {
    var value = null;
    if (this.props.category) {
      value = this.props.category.name;
    }
    return (<HoverValue value={value}/>);

  }
});

var HoverValue = React.createClass({
  isEmptyOrNull : function () {
    return (this.props.value == null
      || this.props.value == ""
      || (this.props.value && this.props.value.length == 0))
      && this.props.children == null
      || this.props.isEmpty == true;
  },
  render: function () {
    if (this.isEmptyOrNull()) {
      return (<span>--</span>);
    } else {
      return (
        <span>
          {this.props.value || this.props.children}
        </span>
      );
    }
  }
});

var HoverEmailLink = React.createClass({
  mixins: [DisplayTextMixin],
  isEmptyOrNull : function () {
    return this.props.value == null
      || this.props.value == "";
  },
  getHref: function () {
    if (this.props.value) {
      return "mailto:" + this.props.value + "?cc=" + this.props.dropbox;
    } else {
      return null;
    }
  },
  render: function () {
    return (
      <HoverValue isEmpty={this.isEmptyOrNull()}>
        <a href={this.getHref()} className="hover-email-link" title={this.props.value}>
          {this.toLowerCase(this.props.value)}
        </a>
      </HoverValue>
    );
  }
});

function PeopleRow(props) {
  return (
    <tr>
      <td className="va-top pr-5">{props.label}</td>
      <td>{props.value}</td>
    </tr>
  );
}

function PeopleListItem(props) {
  return (
    <table className="mb-10">
      <thead>
        <tr>
          <th className="hover-strong pb-3" colSpan="2">{props.name}</th>
        </tr>
      </thead>
      <tbody>
        <PeopleRow label="Cargo:" value={<HoverValue value={props.role}/>}/>
        <PeopleRow label="E-mail:" value={<HoverEmail emails={props.emails} dropbox={props.account_dropbox_email}/>}/>
        <WhatsappField whatsapp={props.social.whatsapp}/>
        <PeopleRow label="Telefone:" value={<Phones data={props.phones}/>}/>
      </tbody>
    </table>
  );
}

function PeopleList(props) {
  const havePeopleData = props.data !== null && props.data.length > 0;
  var peopleRows;

  if (havePeopleData) {
    peopleRows = props.data.map((people, index) => {
      return <PeopleListItem key={index} {...people} />;
    });
  } else {
    peopleRows = <span className="text-muted">Nenhuma pessoa cadastrada para essa empresa</span>;
  }

  return (
    <div className="hover-people-list mah-200 ovy-auto">
      <div className="hover-strong mb-10">Pessoas dessa empresa:</div>
      {peopleRows}
    </div>
  );
}

var CloseButton = ({onClick}) => (
  <button className="close" onClick={onClick}>
    <span className="custom-glyphicon icon-close"></span>
  </button>
);

var HoverOrganization = React.createClass({
  render: function() {
    return (
      <div className="hover-content hover-organization fs-12">
        <div className="hover-title mb-10">
          <CloseButton onClick={this.props.closeFunction} />
          <HoverTitle icon="organization" title={this.props.data.name} />
        </div>
        <div className="hover-body mb-10">
          <div className="address">
            <div className="hover-strong pb-3">Endereço:</div>
            <Address data={this.props.data.address}/>
          </div>
          <hr className="hover-separator"/>
          <div className="hover-contact">
            <table>
              <tbody>
                <tr>
                  <td className="va-top pr-5 pb-2 hover-strong">Categoria:</td>
                  <td><HoverCategory category={this.props.data.category}/></td>
                </tr>
                <tr>
                  <td className="va-top pr-5 pb-2 hover-strong">E-mail:</td>
                  <td><HoverEmail emails={this.props.data.emails} dropbox={this.props.data.account_dropbox_email}/></td>
                </tr>
                <tr>
                  <td className="va-top pr-5 pb-2 hover-strong">Telefone:</td>
                  <td>
                    <Phones data={this.props.data.phones}/>
                  </td>
                </tr>
                <WhatsappField whatsapp={this.props.data.social.whatsapp} classes="pb-2 hover-strong" />
              </tbody>
            </table>
          </div>
          <hr className="hover-separator"/>
          <PeopleList data={this.props.data.people}/>
        </div>
      </div>
    );
  }
});
var HoverPerson = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  render: function() {
    return (
      <div className="hover-content hover-person fs-12">
        <div className="hover-title mb-10">
          <CloseButton onClick={this.props.closeFunction} />
          <HoverTitle icon="person" title={this.props.data.name} subtitle={this.props.data.role}/>
        </div>
        <div className="hover-body mb-10">
          <div className="hover-contact">
            <table>
              <tbody>
                <tr>
                  <td className="va-top pr-5 pb-2 hover-strong">Categoria:</td>
                  <td>
                    <HoverCategory category={this.props.data.category} />
                  </td>
                </tr>
                <tr>
                  <td className="va-top pr-5 pb-2 hover-strong">E-mail:</td>
                  <td>
                    <HoverEmail emails={this.props.data.emails} dropbox={this.props.data.account_dropbox_email} />
                  </td>
                </tr>
                <tr>
                  <td className="va-top pr-5 pb-2 hover-strong">Telefone:</td>
                  <td>
                    <Phones data={this.props.data.phones} />
                  </td>
                </tr>
                <WhatsappField whatsapp={this.props.data.social.whatsapp} classes="pb-2 hover-strong"/>
              </tbody>
            </table>
          </div>
          <hr className="hover-separator"/>
          <div className="address">
            <div className="hover-strong pb-3">Endereço:</div>
            <Address data={this.props.data.address}/>
          </div>
          <hr className="hover-separator"/>
          <div className="birthday">
            <table>
              <tbody>
                <tr>
                  <td className="va-top pr-5 pb-2 hover-strong">Aniversário:</td>
                  <td className="va-top">
                    <Birthday data={this.props.data.birthday} />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <hr className="hover-separator"/>
          <div className="ta-c">
            <Social data={this.props.data.social}/>
          </div>
        </div>
      </div>
    );
  }
});
var HoverDeal = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  truncateTextCallback: function () {
    // This is ugly, but has to be done to re-calculate the popover arrow after the truncate text is open/closed
    if ($ != null) {
      var type = this.props.type;
      var id = this.props.data.id;
      var popover = $("[data-hover-details="+type+"][data-hover-id="+id+"]").data("bs.popover");

      // Recalculate popover bounds and fix arrow position. This is not a native method, we had to implement it.
      // Refer to this issue on Github: https://github.com/twbs/bootstrap/issues/5408
      popover.setPosition();
    }
  },
  render: function() {
    return (
      <div className="hover-content hover-deal fs-12">
        <div className="hover-title mb-10">
          <CloseButton onClick={this.props.closeFunction} />
          <HoverTitle icon="deal" title={this.props.data.title} />
        </div>
        <div className="hover-body mb-10">
          <div className="mh-15">
            <TruncateText text={this.props.data.description} setStateCallback={this.truncateTextCallback}/>
          </div>
          <div className="hover-end-period ta-c mb-10">
            <EndPeriod endsAt={this.props.data.ends_at} dealStatus={this.props.data.deal_status}/>
          </div>
          <div className="hover-deal-status mb-10">
            <DealStatusBox dealStatus={this.props.data.deal_status}/>
          </div>

          <div className="bb-light bt-light">
            <HoverDealOwner userOwner={this.props.data.owner_user}/>
            <HoverDealValue value={this.props.data.value}/>
          </div>
        </div>
        <div className="hover-footer">
          <HoverDealRelatedTo person={this.props.data.person} organization={this.props.data.organization} />
        </div>
      </div>
    );
  }
});

var Hover = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  getInitialState: function() {
    return null;
  },
  getHoverContent: function() {
    if (this.props.type == "empresa") {
      return <HoverOrganization data={this.state} key={this.state.id} closeFunction={this.props.closeFunction}/>;
    } else if (this.props.type == "pessoa") {
      return <HoverPerson data={this.state} key={this.state.id} closeFunction={this.props.closeFunction}/>;
    } else {
      return <HoverDeal data={this.state} key={this.state.id} type={this.props.type} closeFunction={this.props.closeFunction}/>;
    }
  },
  componentDidMount: function () {
    var resourceAPI = apiFactory(this.props.type);
    resourceAPI.get(this.props.token, this.props.id, function(data) {
      this.setState(data, this.setStateCallback);
    }.bind(this));
  },
  setStateCallback: function () {
    if (this.props.onContentLoad) {
      this.props.onContentLoad();
    }
  },
  render: function(){
    var hoverContent = null;
    if (this.state == null || this.state.id == null) {
      hoverContent = <HoverLoader key="-1"/>;
    } else {
      hoverContent = this.getHoverContent();
    }
    return (
      <ReactCSSTransitionGroup transitionName="fade" transitionEnterTimeout={200} transitionLeaveTimeout={0}>
        {hoverContent}
      </ReactCSSTransitionGroup>
    );
  }
});

class WhatsappField extends React.Component {
  constructor(props) {
    super(props);

    this.buildWhatsappURL = this.buildWhatsappURL.bind(this);
  }
  buildWhatsappURL() {
    if (this.props.whatsapp) {
      const formattedNumber = this.props.whatsapp.replace(/\(|\)|\-| |\+|\./g, "");
      return "https://wa.me/" + formattedNumber;
    }
  }
  render() {
    const whatsappURL = this.buildWhatsappURL();
    const classes = "va-top pr-5 " + this.props.classes;
    return (
      <tr>
        <td className={classes}>WhatsApp:</td>
        <td>
          {
            this.props.whatsapp
            ? <a href={whatsappURL} target="_blank">{this.props.whatsapp}</a>
            : <span>--</span>
          }
        </td>
      </tr>
    );
  }
}

module.exports = Hover;



// WEBPACK FOOTER //
// ./app/shared/components/Hover/hover.jsx